// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const removeAttachmentFromComment = (commentData, commentFileIdKey, commentFileId) => ({
  ...commentData,
  attachments: commentData.attachments.filter(d => d[commentFileIdKey] !== commentFileId),
})

export default removeAttachmentFromComment
